<template>
  <div class="m-t2">
    <v-layout>
      <v-flex>
        <div class="text-xs-right">
          <v-btn @click="$emit('close')" icon> <v-icon>close</v-icon></v-btn>
        </div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm6 class="text-xs-left">
        <div style="font-size: 20px; font-weight: 600" class="mb-3 primary--text">
          All Coupon Codes
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="text-xs-right">
        <exportxlsx :promisedValue="getXlsxData"></exportxlsx>
      </v-flex>
    </v-layout>
    <!-- :pagination.sync="pagination" -->
    <v-data-table
      :headers="headers"
      :items="dataAllCodes"
      hide-actions
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.code_type }}</td>
          <td>{{ props.item.code_used ? 'ใช้งานแล้ว' : 'ยังไม่ได้ใช้' }}</td>
        </tr>
      </template>
    </v-data-table>
    <div class="mt-2">
      <v-pagination
        :total-visible="15"
        v-model="pageNumber"
        @input="changePage"
        :length="pagelength"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'

export default {
  components: {
    exportxlsx
  },
  props: ['selectedData'],
  data() {
    return {
      loading: false,
      pagetmp: 1,
      offset: 0,
      limit: 100,
      pageNumber: 1,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      dataAllCodes: [],
      headers: [
        { text: 'Coupon Code', value: 'code', sortable: false },
        { text: 'E-shop/Offline Code', value: 'code_type', sortable: false },
        { text: 'Status', value: 'code_used', sortable: true }
      ]
    }
  },
  mounted() {
    if (this.selectedData) {
      this.getAllCodes()
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 100)
      } else {
        return 1
      }
    }
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.isExport = true
        this.limit = this.total
        var vm = this
        var data = await this.getAllCodes()

        resolve(
          data.map((el) => {
            return {
              ประเภทสมาชิก: vm.selectedData.member_type,
              หมวดหมู่ของรางวัล: vm.selectedData.gift_type,
              ของรางวัล: vm.selectedData.product_name,
              Coupon_Code: el.code,
              Eshop_Offline: el.code_type,
              สถานะ: el.status ? 'ใช้งานแล้ว' : 'ยังไม่ได้ใช้งาน'
            }
          })
        )

        this.isExport = false
        this.limit = 100
      })
    },
    getAllCodes() {
      return new Promise(async (resolve) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid,
          product_id: vm.selectedData.product_id,
          gift_type: vm.selectedData.gift_type,
          member_type: vm.selectedData.member_type,
          limit: vm.limit, // optional
          offset: vm.offset // optional
        }

        vm.loading = true
        api.getLamyRedeemAllCodeById(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.dataAllCodes = response.data
            vm.total = response.total
            vm.loading = false
            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    changePage(val) {
      var vm = this
      if (vm.pagetmp == val) {
        //dont do shit
      } else {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * 100 - 100

        vm.getAllCodes()
      }
    }
  } // End methods
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/ModalShowRedeemCode.vue